import React from 'react';

const ExportButton = ({ onExport }) => {
  return (
    <button 
      className="btn btn-secondary"
      onClick={onExport}
      title="Export current filtered data to CSV"
    >
      📊 Export CSV
    </button>
  );
};

export default ExportButton;
